import React from "react";
import { Box } from "@mui/material";
import ApplicationPrintCardInfoItem from "my-tax/components/application-print-card-info-item";

export const MyTaxEligibilityQualityInfo = () => {
  return (
    <Box style={{ padding: "16px" }}>
      <Box textAlign="center">{"Jogosultság jogcímei:"}</Box>
      <Box
        style={{
          color: "#919699",
          marginTop: "4px",
          lineHeight: "24px",
        }}
      >
        <ApplicationPrintCardInfoItem
          label="a."
          value="Gyermek után családi pótlékra jogosult vagy ilyen jogosulttal közös háztartásban élő házastárs,"
        />
        <ApplicationPrintCardInfoItem
          label="b."
          value="Várandós nő vagy várandós nő közös háztartásban élő házastársa,"
        />
        <ApplicationPrintCardInfoItem
          label="c."
          value="Családi pótlékra saját jogán jogosult, vagy ilyen jogosulttal közös háztartásban élő hozzátartozó (ideértve a gyermek szüleinek hozzátartozóit is),"
        />
        <ApplicationPrintCardInfoItem
          label="d."
          value="Rokkantsági járadékban részesülő vagy ilyen személlyel közös háztartásban  élő hozzátartozó."
        />
      </Box>
    </Box>
  );
};

export default MyTaxEligibilityQualityInfo;
